import SettingPassword from './SettingPassword';

export default SettingPassword;



// WEBPACK FOOTER //
// ./src/components/settings/SettingPassword/index.js